import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { TenantProvider } from "@/context/TenantContext";
import { DashboardShell } from "@/components/DashboardShell";
import {
  LayoutDashboard, Calendar, CalendarCheck, Heart, Wallet, History,
} from "lucide-react";
import ClientHomePage from "./client/ClientHomePage";
import BookPage from "./client/BookPage";
import AppointmentsPage from "./client/AppointmentsPage";
import FidelityPage from "./client/FidelityPage";
import WalletPage from "./client/WalletPage";
import HistoryPage from "./client/HistoryPage";

function ClientDashboardInner() {
  const { slug } = useParams();
  const NAV = [
    { to: `/${slug}/app`, label: "Home", icon: LayoutDashboard, testId: "home", end: true },
    { to: `/${slug}/app/book`, label: "Prenota", icon: Calendar, testId: "book" },
    { to: `/${slug}/app/appointments`, label: "Appuntamenti", icon: CalendarCheck, testId: "appointments" },
    { to: `/${slug}/app/fidelity`, label: "Fidelity", icon: Heart, testId: "fidelity" },
    { to: `/${slug}/app/wallet`, label: "Wallet", icon: Wallet, testId: "wallet" },
    { to: `/${slug}/app/history`, label: "Trattamenti", icon: History, testId: "history" },
  ];
  return (
    <DashboardShell nav={NAV} testId="client-dashboard">
      <Routes>
        <Route index element={<ClientHomePage />} />
        <Route path="book" element={<BookPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="fidelity" element={<FidelityPage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="*" element={<Navigate to={`/${slug}/app`} replace />} />
      </Routes>
    </DashboardShell>
  );
}

export default function ClientDashboard() {
  return (
    <TenantProvider>
      <ClientDashboardInner />
    </TenantProvider>
  );
}
